/**
 * Compatibility utilities for native app bridges
 */

/**
 * Retrieves Firebase device token from available native bridges.
 * Checks in order of priority:
 * 1. OrderMagePlugin (React Native bridge) - async
 * 2. ObjednameInterface (legacy bridge) - sync
 * 3. currentFirebaseToken (global fallback)
 */
export async function getFirebaseDeviceToken(): Promise<string | null> {
    if (typeof window.OrderMagePlugin?.getFirebaseToken === 'function') {
        return window.OrderMagePlugin.getFirebaseToken();
    }

    if (typeof window.ObjednameInterface?.getFirebaseToken === 'function') {
        return window.ObjednameInterface.getFirebaseToken();
    }

    if (window.currentFirebaseToken) {
        return window.currentFirebaseToken;
    }

    return null;
}

export async function requestFirebaseDeviceToken(): Promise<void> {
    if (!window.webkit?.messageHandlers?.ObjednameInterface) {
        return;
    }

    window.webkit.messageHandlers.ObjednameInterface.postMessage({
        fnName: 'getFirebaseToken',
    });
}

if (typeof window !== 'undefined') {
    requestFirebaseDeviceToken();
}
